export function connectRealtimeNotifications({ token, onNotification, onStatusChange }) {
  if (!token) return () => {};

  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const wsUrl = `${protocol}//${new URL(process.env.REACT_APP_BACKEND_URL).host}/ws/notifications?token=${encodeURIComponent(token)}`;

  let socket = null;
  let stopped = false;
  let reconnectTimer = null;

  const connect = () => {
    if (stopped) return;

    try {
      socket = new WebSocket(wsUrl);

      socket.onopen = () => {
        onStatusChange?.(true);
      };

      socket.onmessage = (event) => {
        try {
          const notification = JSON.parse(event.data);
          onNotification?.(notification);
        } catch (_) {}
      };

      socket.onerror = () => {
        onStatusChange?.(false);
      };

      socket.onclose = () => {
        onStatusChange?.(false);
        if (!stopped) {
          reconnectTimer = setTimeout(connect, 3000);
        }
      };
    } catch (_) {
      onStatusChange?.(false);
      if (!stopped) {
        reconnectTimer = setTimeout(connect, 3000);
      }
    }
  };

  connect();

  return () => {
    stopped = true;
    if (reconnectTimer) clearTimeout(reconnectTimer);
    if (socket) socket.close();
  };
}
